/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const productInitialLoadingState = {
  name: false,
  pricing: false,
  sfProductLink: false,
  ownerId: false,
  description: false,
  prerequisites: false,
};
